/* eslint-disable no-unused-vars */
export enum ModelStatus {
    NONE,
    NEW,
    UPDATE,
    DELETE
}
